import React from 'react'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Route, Switch } from "react-router-dom";

import Galeria from './Components/Galeria/Galeria'
import Home from  './Components/Home/Home'

import { StoreProvider } from './store';

function App({worker}) {
  
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const theme = React.useMemo(
    () =>
      createMuiTheme({
        palette: {
          type: 'dark',// prefersDarkMode ? 'dark' : 'light',
        },
      }),
    [prefersDarkMode],
  );

  return (
  
		<ThemeProvider theme={theme}>
      <CssBaseline/>
			<StoreProvider>
			<Switch>
           
          {/* <Route path="/pic/:section" children={<Galeria worker={worker} />} /> */}
          {/* <Route path="/pic" children={<Home />} /> */}
          {/* <Route path="/:section" children={<Galeria worker={worker} />} /> */}
          <Route path="/" children={<Galeria />} />
        </Switch>
				</StoreProvider>  
    </ThemeProvider>
		
  );
  
  // return (
  //   <div className="App">
  //     <Galeria />
  //   </div>
  // );
}

export default App;
